import React, { type ComponentType } from 'react';
import withInjectedProps from '@atlassian/jira-common-util-with-injected-props';
import ProjectDirectoriesApp from '@atlassian/jira-project-directories-components';
import { SubProductUpdater } from '@atlassian/jira-spa-apps-common/src/analytics-sub-product';
import Components from './view';

const Updater: ComponentType<{}> = () => <SubProductUpdater subProduct="platform" />;

export default withInjectedProps(Components, {
	ProjectDirectoriesApp,
	Updater,
});
